import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  AddCountryAction,
  UpdateCountryAction,
} from "store/middlewares/dataManagement/country";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import { SubmitLoaderButton } from "components/atoms";
// import { openToast } from "store/slices/common/toast.slice";
// import DefaultImg from "assets/images/PNG/defaultImage.jpg";
// import ImageEdit from "assets/images/SVG/ImageEditIcon.svg";

function ModalEditCountry({ row }) {
  const dispatch = useDispatch();

  const [formError, setFormError] = useState(false);
  // const [previewImage, setPreviewImage] = useState();

  // useEffect(() => {
  //   if (row) {
  //     setPreviewImage(row?.image_url);
  //   }
  // }, [row]);

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   const fileSizeLimit = 2 * 1024 * 1024; // 2MB limit
  //   const reader = new FileReader();

  //   if (file) {
  //     if (file.size <= fileSizeLimit) {
  //       reader.onload = () => {
  //         setSelectedImage(reader.result);
  //         formik.setFieldValue("file", e.target.files[0]);
  //       };
  //       reader.readAsDataURL(file);
  //     } else {
  //       formik.setFieldValue("file", "");
  //     }
  //   }
  // };

  //--------------------- image change function ------------------------------

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   let fileSizeLimit = 5;
  //   const reader = new FileReader();

  //   if (file) {
  //     if (!file.type.match(/^image\/(png|jpeg|jpg|svg(\+xml)?)$/)) {
  //       dispatch(
  //         openToast({
  //           type: "error",
  //           message: "Only images (png, jpeg, jpg, svg) are allowed.",
  //         })
  //       );
  //       return;
  //     }

  //     if (file.size > fileSizeLimit * 1024 * 1024) {
  //       dispatch(
  //         openToast({
  //           type: "error",
  //           message: `Please upload images less than ${fileSizeLimit}MB.`,
  //         })
  //       );
  //       return;
  //     }

  //     reader.onload = () => {
  //       formik.setFieldValue("image", reader.result);
  //       formik.setFieldValue("file", file);
  //       formik.setFieldError("image", "");
  //       formik.setFieldTouched("image", "");
  //     };

  //     reader.readAsDataURL(file);
  //     setPreviewImage(URL.createObjectURL(file));
  //   }
  // };

  const handleSubmit = (values) => {
    const updateValue = { ...values, name: values.name.trim() };

    let tempObj = { ...updateValue, countryCode: `+${values.countryCode}` };
    if (row) {
      tempObj = {
        ...tempObj,
        id: row?.id,
        // image: row?.image,
      };
      dispatch(
        UpdateCountryAction({
          ...tempObj,
          onSuccess: () => {
            formik.setSubmitting(false);

            // maybe close modal or something
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false); // need to reset submitting on error too
          },
        }),
      );
    } else {
      dispatch(
        AddCountryAction({
          ...tempObj,
          filter: { page: 1, pageSize: 10 },
          onSuccess: () => {
            formik.setSubmitting(false);
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      name: row?.name ? row?.name : "",
      countryCode: row?.country_code.replace("+", "") ?? "",
      // file: null,
      // image: row?.image_url ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Country name is required"),
      countryCode: Yup.string().required("Country code is required"),
      // image: Yup.string().required("Image is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  // useEffect(() => {
  //   console.log(formik.errors);
  // }, [formik]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Country</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            {/* <div className="flex flex-col mt-2 justify-center items-center gap-x-2.5">
              <div className="relative">
                <div className="size-24 overflow-hidden rounded-[50%]">
                  <img
                    src={previewImage ?? DefaultImg}
                    alt="flag"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="absolute bottom-0 right-0 h-[35px] w-[35px] rounded-[50%] bg-white flex items-center justify-center">
                  <input
                    type="file"
                    name="file"
                    accept="image/png, image/jpeg,image/jpg"
                    id="editimg"
                    onChange={(e) => {
                      handleFileChange(e);
                    }}
                    hidden
                  />
                  <label htmlFor="editimg" className="cursor-pointer">
                    <img src={ImageEdit} alt={""} />
                  </label>
                </div>
              </div>
              {formik.errors.image && formik.touched.image && (
                <div className="text-[0.8125rem] text-red-500 text-center">
                  {formik.errors.image}
                </div>
              )}
            </div> */}
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name</Label>
              <Input
                error={formik.errors.name && formik.touched.name}
                errorMsg={formik.errors.name}
                value={formik.values.name}
                type="text"
                name="name"
                maxLength={50}
                isSpace={true}
                onChange={(e) => {
                  let val = e.target.value;
                  val = val.replace(/[^A-Za-z\s]/g, "");
                  formik.setFieldValue("name", val);
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasted = e.clipboardData.getData("text/plain");
                  const cleaned = pasted.replace(/[^A-Za-z\s]/g, "");
                  const current = formik.values.name;
                  formik.setFieldValue("name", current + cleaned);
                }}
                onBlur={formik.handleBlur}
                isTextOnly={true}
                placeholder="Enter country name"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Country Code</Label>
              <Input
                error={formik.errors.countryCode && formik.touched.countryCode}
                errorMsg={formik.errors.countryCode}
                value={formik.values.countryCode}
                type="text"
                isSpace={true}
                isNumeric={true}
                name="countryCode"
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("countryCode", onlyNumbers);
                }}
                maxLength={5}
                onBlur={formik.handleBlur}
                placeholder="Enter country code"
                className={"!py-0 w-full"}
                suggestions="off"
              />
            </div>
            <div className="flex justify-center">
              <SubmitLoaderButton
                btnText="Update"
                isDisable={formik.isSubmitting && !formError}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditCountry;
